// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1_d9v","loaderOuter":"PageOverlayLoader_loaderOuter__3iGWV"};